require('dotenv').config()

module.exports = {

  MAX_LENGTH: {
    USER_ID: 10,
    TITLE: 150,
    CONTENT: 20000,
    TOKENS: 80,
    NAMES: 50,
    SYMBOLS: 100,
    CUSTOM_SYMBOLS: 500,
  },

  // ID's from the "Roles" table
  USER_ROLES: {
    INSTRUCTOR: 1,
    STUDENT: 2,
    SUPER_ADMIN: 3,
  },

  // Question types
  QUESTION_TYPES: {
    answerinput: 1,
    coding: 2,
    select: 3,
  },

  // Question types key names
  QUESTION_TYPES_LABELS: {
    answerinput: 'Numeric and Symbolic',
    coding: 'Coding',
    select: 'Select',
  },

  // Library types
  LIBRARY_TYPES: {
    // default: 1,
    circuits: 2,
    matlab: 3,
  },

  ADMIN_USER_ID: '00000000',
  SUPER_QUIZ_ID: 484,
  MAX_PAGE_LIMIT: 20,
  BASE_URL: 'https://canvas.mathsmithllc.com/',

  MATLAB_VARIABLE_TYPES: [
    'numeric',
    'integer',
    'float',
    'char',
    'logical',
    'vector',
  ],
  
  MATLAB_FILE_PATH: '/tmp/matlab-dump/',

  DATA_TYPE: {
    INTEGER: 1,
    STRING: 2,
    BOOLEAN: 3,
    ARRAY: 4,
    OBJECT: 5,
    DATE: 6,
    UNDEFINED: 7,
  },

  ITEM_TYPES: {
    MODULE: 0,
    ASSIGNMENT: 1,
  },
}